<p-toast position="top-center" [baseZIndex]="9999"></p-toast>
<app-breadcrumb
  path="Orçamento Nº {{ budget?.id }} "
  [showTitle]="true"
></app-breadcrumb>

<div class="budget-main" *ngIf="!!budget">
  <div class="container" id="id-div-budget-print" style="display: none"></div>
  <div class="container" id="id-div-budget-visual">
    <div class="budget-left">
      <div class="budget-left-client">
        <h2>CLIENTE</h2>
        <p class="mobile-invisible">
          {{ budget.user?.name }}
          <span *ngIf="budget?.user?.document">
            | {{ budget.user?.documentFormat() }}</span
          >
        </p>
        <p class="mobile-visible">
          {{ budget.user?.name }}
        </p>
        <p class="mobile-visible">
          {{ user?.isCompany ? "CNPJ:" : "CPF:" }}
          <span> {{ budget.user?.documentFormat() }}</span>
        </p>
        <p class="mobile-invisible">
          Telefone: <span> {{ budget.user?.phone }} </span
          >{{ budget.user?.email ? "| E-mail: " : ""
          }}<span *ngIf="budget?.user?.email"> {{ budget.user?.email }}</span>
        </p>
        <p class="mobile-visible">
          Telefone: <span> {{ budget.user?.phone }} </span>
        </p>
        <p class="mobile-visible" *ngIf="budget?.user?.email">
          Email:<span> {{ budget.user?.email }}</span>
        </p>
        <p>
          Endereço:
          <span [innerHTML]="budget.address?.getAddressDescription()"> </span>
        </p>
      </div>
      <div class="budget-left-products">
        <h2>PRODUTOS</h2>

        <div
          class="budget-left-products-item"
          *ngFor="let item of budget.cart?.cartProducts"
        >
          <div class="budget-left-products-item-img">
            <a href="{{ item?.product?.url }}" target="_blank">
              <img
                [src]="
                  item?.product?.mainPhotoS3Url ||
                  item?.product?.photos?.slice()?.shift()?.url ||
                  ''
                "
                [alt]="item?.product?.name"
                width="{{ isMobile ? 50 : 50 }}"
                height="{{ isMobile ? 50 : 50 }}"
              />
            </a>
            <p>
              {{ item?.product?.name }}
              {{
                (item?.discountPercent || 0) > 0
                  ? " - " + item?.discountPercent + "% OFF"
                  : ""
              }}
              <span *ngIf="item?.product?.productPerSquareMeter">
                {{
                  item?.product?.productPerSquareMeter
                    ? "Largura: " +
                      item?.customWidth?.toFixed(2) +
                      "m x Altura: " +
                      item?.customHeight?.toFixed(2) +
                      "m"
                    : ""
                }}
              </span>

              <span *ngIf="item?.product?.isPersiana()">
                {{ item?.driveDescription }}
                | {{ item?.controlSideDescription }}
                {{
                  item?.product?.isPersianaRomana()
                    ? ""
                    : " | " + item?.panelDescription
                }}
              </span>

              <span>
                {{ "Marca: " + item?.product?.brandDescription || "" }} -
                {{ "Código: " + item?.product?.id }}</span
              >
            </p>
          </div>

          <div class="budget-left-products-item-value">
            <div>
              <p
                [ngClass]="{
                  'with-discount': (item?.discountPercent || 0) > 0
                }"
              >
                {{ getValueItem(item, false) | customCurrencyLight }}
              </p>
              <p *ngIf="(item?.discountPercent || 0) > 0">
                {{ getValueItem(item, true) | customCurrencyLight }}
              </p>
            </div>
          </div>

          <div class="budget-left-products-item-qtd mobile-invisible">
            <span>{{ item.amount }}</span>
          </div>

          <div class="budget-left-products-item-value">
            <span class="mobile-visible">Quantidade: {{ item.amount }}</span>
            <div>
              <p
                [ngClass]="{
                  'with-discount': (item?.discountPercent || 0) > 0
                }"
              >
                {{
                  getValueItem(item, false) * (item?.amount || 0)
                    | customCurrencyLight
                }}
              </p>
              <p *ngIf="(item?.discountPercent || 0) > 0">
                {{
                  getValueItem(item, true) * (item?.amount || 0)
                    | customCurrencyLight
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="budget?.observations" class="budget-left-observations">
        <h2>OBESERVAÇÕES</h2>
        <div class="p-editor-content ql-container ql-snow">
          <div
            class="ql-editor"
            [innerHTML]="budget.observations | safe : 1"
          ></div>
        </div>
      </div>
      <div class="budget-left-seller">
        <p>
          Vendedor(a):
          <span> {{ budget.creatorUser?.name }}</span>
        </p>
      </div>
    </div>
    <div class="budget-right">
      <div class="budget-right-packing">
        <h2>EMBALAGENS</h2>
        <p>
          Volume:
          <span> {{ budget.volume }}</span>
        </p>
        <p>
          Peso total:
          <span> {{ getTotalWeight() }}</span>
        </p>
      </div>
      <div class="budget-right-delivery">
        <h2>ENTREGA</h2>
        <div class="budget-right-delivery-carrier">
          <p>
            {{ budget.carrierDescription }}
            <span>{{ budget.valueFreight | customCurrencyLight }}</span>
          </p>
          <p>
            Prazo de entrega<span>{{ budget.deliveryTime }} dias úteis</span>
          </p>
        </div>
      </div>

      <div class="budget-right-resume">
        <h2>RESUMO</h2>
        <div class="budget-right-resume-value">
          <p>
            Total Produtos
            <span>{{ budget.cart?.valueSubtotal | customCurrencyLight }}</span>
          </p>
          <p class="discount" *ngIf="budget.cart?.haveProductDiscount">
            Desconto produtos à vista ({{
              budget.cart?.percentDiscountProduct
            }}%)
            <span>-{{ budget.cart?.valueDiscount | customCurrencyLight }}</span>
          </p>
          <p class="discount" *ngIf="(budget.cart?.discountSeller || 0) > 0">
            Desconto Vendedor ({{ budget.cart?.discountSeller }}%)
            <span
              >-{{
                budget.cart?.valueDiscountSeller | customCurrencyLight
              }}</span
            >
          </p>
          <p class="discount" *ngIf="(budget.availableCredit || 0) > 0">
            Crédito cliente
            <span>-{{ budget.availableCredit | customCurrencyLight }}</span>
          </p>
          <p *ngIf="(budget.additionalValue || 0) > 0">
            Acréscimo
            <span>{{ budget.additionalValue | customCurrencyLight }}</span>
          </p>
          <p *ngIf="(budget.cart?.valueFreight || 0) > 0">
            Frete
            <span>{{ budget.cart?.valueFreight | customCurrencyLight }}</span>
          </p>
        </div>
      </div>

      <div class="budget-right-payment">
        <h2>OPÇÕES DE PAGAMENTO</h2>
        <p>
          {{
            (budget.cart?.valueTotal || 0) +
              (budget.additionalValue || 0) -
              (budget.availableCredit || 0) | customCurrencyLight
          }}
          à vista, via PIX
          <ng-container *ngIf="budget.cart?.percentDiscountTotal || 0 > 0">
            <i style="color: #e24c4c; font-style: normal">
              &nbsp;com {{ budget.cart?.percentDiscountTotal }}% de desconto
            </i>
          </ng-container>
        </p>
        <p *ngIf="(budget?.cart?.discountSeller || 0) > 0">
          {{
            (budget.cart?.valueTotal || 0) +
              (budget.cart?.valueDiscountSeller || 0) +
              (budget.additionalValue || 0) -
              (budget.availableCredit || 0) | customCurrencyLight
          }}
          em 4x sem juros
          <ng-container *ngIf="budget.cart?.percentDiscountTotal || 0 > 0">
            <i style="color: #e24c4c; font-style: normal">
              &nbsp;com {{ budget.cart?.percentDiscountProduct }}% de desconto
            </i>
          </ng-container>
        </p>
        <p *ngIf="(budget?.cart?.discountSeller || 0) <= 0">
          em 4x de {{ getInstallmentValue(4) | customCurrencyLight }} sem juros
        </p>
        <p>ou</p>
        <p>
          <span
            >5x de {{ getInstallmentValue(5) | customCurrencyLight }} com
            juros</span
          >
        </p>
        <p>
          <span
            >8x de {{ getInstallmentValue(8) | customCurrencyLight }} com
            juros</span
          >
        </p>
        <p>
          <span
            >12x de {{ getInstallmentValue(12) | customCurrencyLight }} com
            juros</span
          >
        </p>

        <h3 *ngIf="budget?.status !== 'CLOSED'">
          para ver outras opções de pagamento clique em finalizar
        </h3>
        <button
          *ngIf="budget?.status !== 'CLOSED'"
          type="button"
          pButton
          pRipple
          icon="pi pi-lock"
          iconPos="right"
          class="button-rm"
          aria-label="Finalizar sua compra"
          label="FINALIZAR SUA COMPRA"
          (click)="onClickCheckout()"
        ></button>

        <button
          *ngIf="budget?.status === 'CLOSED'"
          type="button"
          pButton
          pRipple
          icon="pi pi-check"
          iconPos="right"
          class="button-rm-2"
          aria-label="ORÇAMENTO EXPIRADO"
          label="ORÇAMENTO EXPIRADO"
        ></button>

        <p class="budget-right-payment-footer">
          <a target="_blank" href="politicas-trocas-cancelamentos"
            >Trocas, Devoluções e Políticas de Entrega</a
          >
          <a target="_blank" href="termos-condicoes-uso">Termos e Condições</a>
          <a target="_blank" href="aviso-de-privacidade"
            >Aviso de Privacidade</a
          >
          <a target="_blank" href="faq">Perguntas Frequentes</a>
          <a target="_blank" href="fale-conosco">Fale Conosco</a>
        </p>
      </div>
    </div>
  </div>
</div>

<div class="budget-has-no-item" *ngIf="!budget">
  <app-has-no-itens
    [title]="'orçamento não encontrado!'"
    [labelButton]="'comprar produtos'"
    [route]="'/coberturas-em-policarbonato/policarbonato-alveolar'"
  ></app-has-no-itens>
</div>
